/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2013, 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 * VisDefinitions
 */
define([
	'underscore',
	'../../lib/@waca/core-client/js/core-client/ui/core/Class'
], function (_, Class) {

	var VisDefinitions = null;

	VisDefinitions = Class.extend({

		init: function (params) {

			VisDefinitions.inherited('init', this, arguments);

			this.mapDefinitionsById = {};
			this.jsonDefinitions = {};

			if (params) {
				this.jsonDefinitions = params.jsonDefinitions;
				for (var i = 0; i < params.jsonDefinitions.length; i++) {
					var def = params.jsonDefinitions[i];
					this.mapDefinitionsById[def.id] = def;
				}
			}
		},

		getDefinitionById: function (id) {
			return this.mapDefinitionsById[id];
		},

		// return an array of all available definitions
		getDefinitions: function () {
			return this.jsonDefinitions;
		},

		removeObsoleteCachedVisDefinitions() {
			const cachedDefIds = Object.keys(this.mapDefinitionsById);
			const allIds = this.jsonDefinitions.map(def => {
				return def.id;
			});
			const idsNoLongerExist = _.difference(cachedDefIds, allIds);
			idsNoLongerExist.forEach(id => {
				delete this.mapDefinitionsById[id];
			});
		}

	});

	return VisDefinitions;
});
